const getRequests = async (axiosPrivate, token) => {
  try {
    const response = await axiosPrivate.get("/user/getRequests", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching requests:", error);
    throw error;
  }
};

const getDetailsOfUser = async (axiosPrivate, userID, token) => {
  try {
    const response = await axiosPrivate.get(
      `/user/getDetailsOfUser/${userID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching donor data:", error);
    throw error;
  }
};

const chat = async (axiosPrivate, question, userID, token) => {
  try {
    const response = await axiosPrivate.post(
      "/user/chat",
      { question: question, userId: userID },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching answer:", error);
    throw error;
  }
};

const deleteRequest = async (axiosPrivate, reqId, token) => {
  try {
    const response = await axiosPrivate.delete(`/user/delReq/${reqId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error deleting request:", error);
    throw error;
  }
};

const uploadImage = async (axiosPrivate, userID, downloadURL, token) => {
  try {
    const response = await axiosPrivate.post(
      "/user/uploadImage",
      {
        user_id: userID,
        image: downloadURL,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

const getRequestDetails = async (axiosPrivate, reqId, token) => {
  try {
    const response = await axiosPrivate.get(
      `/user/getRequestDetails/${reqId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching request details:", error);
    throw error;
  }
};

const getAllDonationsOfUser = async (axiosPrivate, userID, token) => {
  try {
    const response = await axiosPrivate.get(
      `/user/getAllDonationsofUser/${userID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching donations:", error);
    throw error;
  }
};

const deleteUser = async (axiosPrivate, userID, token) => {
  try {
    const response = await axiosPrivate.delete(`/user/delUser/${userID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

export {
  getRequests,
  getDetailsOfUser,
  chat,
  deleteRequest,
  uploadImage,
  getRequestDetails,
  getAllDonationsOfUser,
  deleteUser,
};
